import { Icon } from 'common-front/src/designSystem/components/icon';
import { Box } from 'common/src/designSystem/components/box';
import { Flex } from 'common/src/designSystem/components/flex';
import { IIcon } from 'common/src/designSystem/components/i';
import * as React from 'react';

interface IWorkflowBoxProps {
    category: string;
    children: React.ReactNode;
    icon: IIcon;
    title: string;
}

export const WorkflowBox = (props: IWorkflowBoxProps) => (
    <Flex
        css={{
            background: 'white',
            bd: true,
            padding: '$4',
            width: 'min($container, 100%)'
        }}
        direction="column"
        gap="5"
    >
        <Flex
            css={{
                borderBottom: '1px solid $gray200',
                paddingBottom: '$3'
            }}
            gap="3"
            width={1}
        >
            <Icon color="gray" icon={props.icon} />

            <Flex direction="column">
                <Box font="gray500 textXs regular">{props.category}</Box>

                <Box font="gray800 textSm medium">{props.title}</Box>
            </Flex>
        </Flex>

        <Flex direction="column" gap="4" width={1}>
            {props.children}
        </Flex>
    </Flex>
);
